// extracted by css-extract-rspack-plugin
export default {"icon":"product-detail-fragment__ProductDuration_icon__Q6QIk"};